<div class="main-container">
    <div class="filters-container">
      <div class="filters-group">
        <!-- <div class="filter-item">
          <label>Module</label>
          <div class="select-wrapper">
            <select [(ngModel)]="selectedModule" (ngModelChange)="onFilterChange()" class="filter-select">
              <option value="">All Modules</option>
              <option *ngFor="let module of modules" [value]="module">
                {{ module }}
              </option>
            </select>
            <i class="bi bi-chevron-down"></i>
          </div>
        </div> -->
  
        <!-- <div class="filter-item">
          <label>Activity</label>
          <div class="select-wrapper">
            <select [(ngModel)]="selectedActivity" (ngModelChange)="onFilterChange()" class="filter-select">
              <option value="">All Activities</option>
              <option *ngFor="let activity of activities" [value]="activity">
                {{ activity }}
              </option>
            </select>
            <i class="bi bi-chevron-down"></i>
          </div>
        </div> -->
  
        <!-- <div class="filter-toggle">
          <label class="toggle-switch">
            <span>Advanced Search</span>
            <mat-slide-toggle [(ngModel)]="advancedSearch" (change)="toggleAdvancedSearch()"></mat-slide-toggle>
          </label>
        </div> -->
      </div>
    </div>
  
    
    <div class="table-container">
        <div class="search-section">
        <div class="search-container">
          <i class="bi bi-search"></i>
          <input class="search-text" type="text" placeholder="Search for Audits..." 
                 [(ngModel)]="searchQuery" (ngModelChange)="fetchAuditLogs()">
        </div>
        <!-- <div class="view-options">
          <button 
            class="sort-btn" 
            mat-raised-button 
            [matMenuTriggerFor]="sortMenu">
            <i class="material-icons">sort</i>
          </button>
          
          <mat-menu #sortMenu="matMenu">
            <button 
              *ngFor="let option of sortOptions" 
              mat-menu-item 
              (click)="option.action()">
              <i class="material-icons">{{option.icon}}</i>
              <span>{{ option.label }}</span>
            </button>
          </mat-menu>
        </div> -->
      </div>
      <table>
        <thead>
          <tr>
            <th (click)="sortData('timestamp')" style="width: 200px;">
              Timestamp 
              <i class="bi" [ngClass]="getSortIcon('timestamp')"></i>
            </th>
            <th (click)="sortData('module')">
              Module
              <i class="bi" [ngClass]="getSortIcon('module')"></i>
            </th>
            <!-- <th (click)="sortData('activity')">
              Activity
              <i class="bi" [ngClass]="getSortIcon('activity')"></i>
            </th> -->
            <!-- <th (click)="sortData('user')">
              User
              <i class="bi" [ngClass]="getSortIcon('user')"></i>
            </th> -->
            <th (click)="sortData('description')">
              Description
              <i class="bi" [ngClass]="getSortIcon('description')"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of filteredData | slice:startIndex:endIndex">
            <td>
              {{ item.timestamp | date: 'MMM d, yyyy hh:mm a' }}
            </td>
            <td>{{ item.module }}</td>
            <!-- <td>{{ item.activity }}</td> -->
            <!-- <td>
              <div class="user-info">
                <div class="user-icon">
                  {{ getUserInitials(item.user) }}
                </div>
                <div class="user-details">
                  <div class="user-name">{{ item.user }}</div>
                  <div class="user-email">{{ item.email }}</div>
                </div>
              </div>
            </td> -->
            <td>{{ item.description }}</td>
          </tr>
        </tbody>
      </table>
  
      <div *ngIf="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
  
      <div *ngIf="isLoading" class="loading">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
  
      <div class="pagination">
        <div class="page-size">
          <select [(ngModel)]="pageSize" (change)="onPageSizeChange($event)">
            <option [value]="5">5</option>
            <option [value]="10">10</option>
            <option [value]="15">15</option>
          </select>
          <span>Rows per page</span>
        </div>
        <div class="page-info">
          <!-- Displaying {{ startIndex + 1 }}-{{ Math.min(endIndex, filteredData.length) }} of {{ filteredData.length }} -->
          Displaying {{ filteredData.length ? startIndex + 1 : 0 }}-{{ endIndex }} of {{ filteredData.length }}
        </div>

        <div class="page-controls">
          <button [disabled]="currentPage === 1" (click)="prevPage()">
            <i class="bi bi-chevron-left"></i>
          </button>
          <button [disabled]="currentPage >= totalPages" (click)="nextPage()">
            <i class="bi bi-chevron-right"></i>
          </button>
        </div>
        
      </div>
    </div>
  </div>